import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import {
  IonCard,
  IonCardContent,
  IonItem,
  IonText,
  IonList,
} from "@ionic/react";

interface props {
  teams: any;
  progress: any;
}

const CrosswordResults: React.FC<props> = ({ teams, progress }) => {
  const [teamStatus, setTeamStatus] = useState<any>([]);

  const score = (team: any) => {
    return team.puzzle?.filter((answer: any) => answer).length;
  };

  useEffect(() => {
    setTeamStatus(
      teams
        .map((team: any) => {
          return {
            teamName: team.teamName,
            score: score(team),
          };
        })
        .sort((a: any, b: any) => b.score - a.score)
    );
    //eslint-disable-next-line
  }, [teams]);

  return (
    <IonCard style={{ maxWidth: "600px" }}>
      <IonCardContent>
        <IonList>
          {teamStatus.map((team: any, i: any) => {
            return (
              <IonItem key={i} lines="full">
                <IonText
                  slot="start"
                  style={{ width: "100%", maxWidth: "70%" }}
                >
                  {team.teamName}
                </IonText>
                <IonText>{team.score}</IonText>
              </IonItem>
            );
          })}
        </IonList>
      </IonCardContent>
    </IonCard>
  );
};
const mapStateToProps = (state: any) => ({
  quizData: state.quiz,
  teams: state.teams.teams,
  progress: state.quiz.progress,
});

export default connect(mapStateToProps, {})(CrosswordResults);
